import {useTranslation} from '@aboutyou/i18n';
import {TrackContentPageView} from '@aboutyou/tracking';
import {FullWidthButton} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {NewsletterLandingPage} from './NewsletterLandingPage';

export const SubscriptionConfirmationLandingPage = () => {
  const {t} = useTranslation();
  return (
    <NewsletterLandingPage
      title={t('Thank you! Your registration was successful.')}
    >
      <TrackContentPageView pageTitle="subscriptionConfirmationLandingPage" />
      <StyledButton
        disableShadow={true}
        type={'primary'}
        withBorder={false}
        href={'/'}
      >
        {t('Continue shopping')}
      </StyledButton>
    </NewsletterLandingPage>
  );
};

const StyledButton = styled(FullWidthButton)`
  display: block;
  border: none;
  span {
    display: block;
  }
`;
